/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store viewed products in localStorage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 24;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {number} [maxProducts] - Maximum number of products to retain.
   */
  static addProduct(productId, maxProducts = this.#MAX_PRODUCTS) {
    let viewedProducts = this.getProducts();
    const limit = Number.isFinite(Number(maxProducts)) ? Math.max(1, Number(maxProducts)) : this.#MAX_PRODUCTS;

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, limit);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from localStorage.
   * @param {number} [maxProducts] - Optional max products to return.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts(maxProducts) {
    const viewedProducts = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    if (maxProducts == null) return viewedProducts;

    const limit = Number.isFinite(Number(maxProducts)) ? Math.max(1, Number(maxProducts)) : this.#MAX_PRODUCTS;
    return viewedProducts.slice(0, limit);
  }
}
